import React, { useState, useEffect, useRef } from 'react';
import Button from '@mui/material/Button';
import { Input, Row, Col, Card, Space, Modal } from 'antd';
import ContentEditor from '../../SuperComponents/ContentEditor/ContentEditor';
import {CollectionsRounded} from "@mui/icons-material";
import ResponseCollection from "../../SuperComponents/Gpt/ResponseCollection";
import Files from "../Files/Files";



const transformEditorJsText = (html) => {
    let doc = new DOMParser().parseFromString(html, 'text/html');
    let contentArray = [];
    let nodes = doc.body.childNodes;
    console.log(html);

    nodes.forEach(node => {
        if (node.nodeName === "BR") {
            contentArray.push({ type: 'paragraph', data: { text: '' } });
        } else if (node.nodeType === Node.TEXT_NODE) {
            const textContent = node.textContent.trim();
            // Handle parentheses as a single unit
            if (textContent.startsWith('(') && textContent.endsWith(')')) {
                contentArray.push({ type: 'paragraph', data: { text: textContent } });
            } else {
                contentArray.push({ type: 'paragraph', data: { text: textContent } });
            }
        } else if (node.nodeName === "B" || node.nodeName === "STRONG") {
            contentArray.push({ type: 'paragraph', data: { text: `<b>${node.innerHTML}</b>` } });
        } else if (node.nodeName === "I" || node.nodeName === "EM") {
            contentArray.push({ type: 'paragraph', data: { text: `<i>${node.innerHTML}</i>` } });
        } else {
            contentArray.push({ type: 'paragraph', data: { text: node.outerHTML } });
        }
    });

    return { time: new Date().getTime(), blocks: contentArray };
};


const TouchpointEditor = ({ touchpoint, onSave, onChangeTitle, onChangeContent }) => {
    const [localTouchpoint, setLocalTouchpoint] = useState(touchpoint);
    const [showFiles, setShowFiles] = useState(false);
    const [transformationQueue, setTransformationQueue] = useState([]);
    const editorRef = useRef(null);  // Reference to the ContentEditor component

    useEffect(() => {
        setLocalTouchpoint(touchpoint);  // Synchronize external changes
    }, [touchpoint]);

    useEffect(() => {
        if (transformationQueue.length > 0) {
            const { html, resolve } = transformationQueue[0];
            const transformedContent = transformEditorJsText(html);
            if (editorRef.current) editorRef.current.updateContent(transformedContent);
            handleContentChange(transformedContent);
            resolve();  // Resolve the promise after transformation
            setTransformationQueue(queue => queue.slice(1));  // Remove the processed item
        }
    }, [transformationQueue]);

    const handleSave = () => {
        onSave(localTouchpoint);
    };

    const handleTitleChange = (e) => {
        const updatedTouchpoint = { ...localTouchpoint, title: e.target.value };
        setLocalTouchpoint(updatedTouchpoint);
        onChangeTitle(updatedTouchpoint.title);
    };

    const handleContentChange = (newContent) => {
        const updatedTouchpoint = { ...localTouchpoint, content: newContent };
        setLocalTouchpoint(updatedTouchpoint);
        onChangeContent(newContent);
    };

    const addToTransformationQueue = (html) => {
        return new Promise(resolve => {
            setTransformationQueue(queue => [...queue, { html, resolve }]);
        });
    };

    const onAddTouchpoint = async (htmlContent) => {
        console.log('Adding touchpoint to editor', htmlContent);
        const parsedContent = transformEditorJsText(htmlContent);
        console.log('Parsed content', parsedContent);
        await addToTransformationQueue(htmlContent);
    };

    return (
        <Row>
            <Col flex={'0 0 840px'}>
                <Card bordered={false} style={{ height: 850, overflowY: 'scroll', padding: 0, background: 'var(--light-grey)' }}>
                    <Row align={'middle'} justify={'space-between'} className={'px-3'} wrap={false}>
                        <Col flex={'0 0 250px'}>
                            <Input
                                value={localTouchpoint?.title || ''}
                                onChange={handleTitleChange}
                                placeholder="Enter Touchpoint Title"
                                style={{ width: '100%', padding: '10px', margin: '20px 0' }}
                            />
                        </Col>
                        <Space size={'middle'}>
                            <Button onClick={() => setShowFiles(true)}>
                                <CollectionsRounded />
                            </Button>
                            <Button variant="contained" color="primary" onClick={handleSave}>
                                Save Touchpoint
                            </Button>
                        </Space>
                    </Row>
                    <ContentEditor ref={editorRef} initialData={localTouchpoint.content} onContentChange={handleContentChange} />
                </Card>
            </Col>
            <Col flex={'1 1 300px'} offset={1}>
                <ResponseCollection onAddTouchpoint={onAddTouchpoint} />
            </Col>
            <Modal open={showFiles} onOk={() => setShowFiles(false)} onCancel={() => setShowFiles(false)} width={'100%'} style={{ height: '90%' }}>
                <Files />
            </Modal>
        </Row>
    );
};

export default TouchpointEditor;
